var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileVendorDetailIcon = function SvgMobileVendorDetailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M5.833 3.334v13.333h8.334V3.334zM5 1.667h10c.46 0 .833.373.833.833v15c0 .46-.373.834-.833.834H5a.833.833 0 0 1-.833-.834v-15c0-.46.373-.833.833-.833m5 12.5a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667"
  })));
};
export default SvgMobileVendorDetailIcon;